import { useEffect, useState } from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const readPrefersReducedMotion = () =>
  typeof window.matchMedia === 'function' &&
  window.matchMedia(REDUCED_MOTION_QUERY).matches;

/** Whether the system asks for reduced motion, kept current. */
export const usePrefersReducedMotion = () => {
  const [isReducedMotion, setIsReducedMotion] = useState(
    readPrefersReducedMotion,
  );

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;

    const query = window.matchMedia(REDUCED_MOTION_QUERY);
    const onChange = () => setIsReducedMotion(query.matches);

    query.addEventListener?.('change', onChange);

    return () => query.removeEventListener?.('change', onChange);
  }, []);

  return isReducedMotion;
};
